// extracted by mini-css-extract-plugin
export default {"zoomLink":"ZoomInfoSelected_zoomLink__Vp7B+"};